const translations = {
  en: {
    'common.loading': 'Loading...',
    'common.logout': 'Logout',
    'common.language': 'Language',
    'common.english': 'English',
    'common.hindi': 'Hindi',
    'common.noCompany': 'No Company',
    'common.cancel': 'Cancel',
    'common.submit': 'Submit',
    'common.uploading': 'Uploading...',
    'common.close': 'Close',
    'common.remove': 'Remove',
    'common.descriptionOptional': 'Description (Optional)',
    'common.title': 'Title',
    'common.priority': 'Priority',
    'common.status': 'Status',
    'common.assignee': 'Assignee',
    'common.selectProject': 'Select Project',
    'common.selectAssignee': 'Select Assignee',
    'common.searchAssignees': 'Search assignees...',
    'common.noAssigneesAvailable': 'No assignees available.',
    'common.dueDateTime': 'Due Date & Time',
    'common.files': 'Files',
    'common.links': 'Links',
    'common.addLink': 'Add Link',
    'common.na': 'N/A',
    'common.project': 'Project',
    'common.startDate': 'Start Date',
    'common.endDate': 'End Date',
    'common.allMembers': 'All Members',
    'common.applyFilters': 'Apply Filters',
    'common.dashboard': 'Dashboard',
    'common.projects': 'Projects',
    'common.createTask': 'Create Task',
    'common.myTasks': 'My Tasks',
    'common.calendar': 'Calendar',
    'common.notifications': 'Notifications',
    'notifications.unread': 'Unread',
    'notifications.read': 'Read',
    'notifications.noNotifications': 'No notifications',
    'notifications.viewAll': 'View All Notifications',
    'notifications.allNotifications': 'All Notifications',
    'notifications.noNotificationsFound': 'No notifications found.',
    'notifications.from': 'From',
    'notifications.live': 'live',
    'manager.teamPerformance': 'Team Member Performance',
    'calendar.title': 'Calendar - Welcome {{name}}',
    'calendar.sun': 'Sun',
    'calendar.mon': 'Mon',
    'calendar.tue': 'Tue',
    'calendar.wed': 'Wed',
    'calendar.thu': 'Thu',
    'calendar.fri': 'Fri',
    'calendar.sat': 'Sat',
    'calendar.tasksOnDate': 'Tasks on {{date}}',
    'calendar.noTasksForDate': 'No tasks for this date.',
    'calendar.selectAction': 'Select Action',
    'calendar.sendForApproval': 'Send for Approval',
    'calendar.submitTask': 'Submit Task',
    'calendar.taskAttachments': 'Task Attachments',
    'calendar.noTaskAttachments': 'No task attachments.',
    'calendar.submission': 'Submission',
    'calendar.noSubmissionAttachments': 'No submission attachments.',
    'teamPerformance.title': 'Team Performance - Welcome {{name}}',
    'teamPerformance.filterTitle': 'Filter Performance Data',
    'teamPerformance.cardsTitle': 'Performance Cards',
    'teamPerformance.noData': 'No performance data available.',
    'teamPerformance.role': 'Role',
    'teamPerformance.totalTasks': 'Total Tasks',
    'teamPerformance.completed': 'Completed',
    'teamPerformance.ongoing': 'Ongoing',
    'teamPerformance.pendingApproval': 'Pending Approval',
    'teamPerformance.overdue': 'Overdue',
    'teamPerformance.efficiencyScore': 'Efficiency Score',
    'teamPerformance.failedFilter': 'Failed to filter appraisal data.',
    'teamPerformance.appraisalEndpointMissing': 'Appraisal report endpoint not found. Please ensure the API is configured.',
    'teamPerformance.accessDenied': 'Access denied. Contact admin for appraisal data.',
    'dashboard.majorTask': 'Major Task',
    'auth.manager': 'Manager',
    'auth.teamMember': 'Team Member',
    'myTasks.failedLoad': 'Failed to load tasks. Please try again.',
    'toast.taskSentApproval': 'Task sent for approval!',
    'toast.failedSendApproval': 'Failed to send task for approval.',
    'toast.taskUpdatedSuccess': 'Task status updated successfully!',
    'toast.failedUpdateTaskStatus': 'Failed to update task status.',
    'manager.welcome': 'Dashboard - Welcome {{name}}',
    'manager.ongoingProjects': 'Ongoing Projects',
    'manager.completedProjects': 'Completed Projects',
    'manager.majorTasksToday': 'Major Tasks Today',
    'manager.pendingApprovals': 'Pending Approvals',
    'manager.noMajorTasksDueToday': 'No major tasks due today.',
    'manager.noPendingApprovals': 'No pending approvals.',
    'manager.noTasksAssigned': 'No tasks assigned to you.',
    'manager.subtaskTitle': 'Subtask Title',
    'manager.teamMember': 'Team Member',
    'manager.action': 'Action',
    'manager.approveTask': 'Approve Task',
    'manager.declineTask': 'Decline Task',
    'manager.taskApprovedSuccess': 'Task approved successfully!',
    'manager.taskDeclinedSuccess': 'Task declined successfully!',
    'manager.failedApproveTask': 'Failed to approve task.',
    'manager.failedDeclineTask': 'Failed to decline task.',
    'createTask.welcome': 'Create Task - Welcome {{role}}',
    'createTask.createMajorTask': 'Create Major Task',
    'createTask.majorTaskName': 'Major Task Name',
    'createTask.subtasks': 'Subtasks',
    'createTask.noSubtasksAdded': 'No subtasks added.',
    'createTask.addSubtask': 'Add Subtask',
    'createTask.attachFilesOptional': 'Attach Files (Optional)',
    'createTask.maxFilesHelp': 'Max 5 files, total 25MB.',
    'createTask.attachLinksOptional': 'Attach Links (Optional)',
    'createTask.maxLinksHelp': 'Max 5 links.',
    'createTask.noLinksAdded': 'No links added.',
    'createTask.dailyActivity': 'Daily task',
    'createTask.submitMajorTask': 'Submit Major Task',
    'createTask.creatingTask': 'Creating Task...',
    'createTask.teamWorkloadOverview': 'Team Workload Overview',
    'createTask.noOngoingTasks': 'No ongoing tasks!',
    'toast.failedLoadData': 'Failed to load data. Please try again.',
    'toast.userDataUnavailable': 'User data not available.',
    'toast.maxLinksAllowed': 'Maximum 5 links allowed.',
    'toast.subtaskFieldsRequired': 'All subtask fields are required except description.',
    'toast.dueFuture': 'Due date & time must be in the future.',
    'toast.subtaskAdded': 'Subtask added. Submit to create task.',
    'toast.taskCreationInProgress': 'Task creation is already in progress. Please wait.',
    'toast.completeRequiredFields': 'Please complete all required fields and add at least one valid subtask.',
    'toast.selectValidProject': 'Please select a valid project.',
    'toast.creatingTaskWait': 'Creating task, please wait...',
    'toast.taskCreated': 'Major task and subtasks created successfully!',
    'toast.failedCreateTask': 'Failed to create task.',
    'task.low': 'Low',
    'task.medium': 'Medium',
    'task.high': 'High',
    'task.ongoing': 'Ongoing',
    'task.completed': 'Completed',
    'landing.homeAria': 'PutPens home',
    'landing.learnMore': 'Learn more',
    'landing.faq': 'FAQ',
    'landing.support': 'Support',
    'landing.menu': 'Menu',
    'landing.home': 'Home',
    'landing.login': 'Log In',
    'landing.heroKicker': 'PutPens',
    'landing.heroLine1': 'Plan better.',
    'landing.heroLine2': 'Build faster.',
    'landing.heroLine3': 'Lead smarter.',
    'landing.heroSubtitle': 'Manage your people and resources smartly now.',
    'landing.getStarted': 'Get Started',
    'landing.bookDemo': 'Book Demo',
    'landing.alreadyStarted': 'Already started signing up?',
    'landing.whyTitle': 'Why PutPens?',
    'landing.whyBody': "PutPens simplifies project management in an intuitive way. Plan projects, assign tasks, and track progress effortlessly with your team. It's the smart way to lead and succeed on every job site.",
    'landing.feature1Title': 'Transparent Appraisals',
    'landing.feature1Body': 'Automated appraisals based on completed tasks, deadlines, and quality scores.',
    'landing.feature2Title': 'Smart Reminders',
    'landing.feature2Body': 'Automated reminders and follow-ups to ensure timely completion.',
    'landing.feature3Title': 'Performance Insights',
    'landing.feature3Body': 'Real-time analytics to track team performance and productivity.',
    'landing.ctaTitle': 'Ready to get started?',
    'landing.ctaBody': 'Start your free trial or talk to our team. Everything in PutPens is designed with a calm purple visual system and clear hierarchy.',
    'landing.startTrial': 'Start Your Free Trial',
    'landing.exploreFaq': 'Explore FAQs',
    'landing.needHelp': 'Need Help?',
    'landing.helpBody': 'Facing a problem or have a question? Our team is here to help.',
    'landing.goSupport': 'Go to Support',
    'landing.contactSales': 'Contact Sales',
    'landing.footer': '© 2025 PutPens. All rights reserved.',
  },
  hi: {
    'common.loading': 'लोड हो रहा है...',
    'common.logout': 'लॉगआउट',
    'common.language': 'भाषा',
    'common.english': 'अंग्रेज़ी',
    'common.hindi': 'हिंदी',
    'common.noCompany': 'कोई कंपनी नहीं',
    'common.cancel': 'रद्द करें',
    'common.submit': 'सबमिट करें',
    'common.uploading': 'अपलोड हो रहा है...',
    'common.close': 'बंद करें',
    'common.remove': 'हटाएं',
    'common.descriptionOptional': 'विवरण (वैकल्पिक)',
    'common.title': 'शीर्षक',
    'common.priority': 'प्राथमिकता',
    'common.status': 'स्थिति',
    'common.assignee': 'असाइनी',
    'common.selectProject': 'प्रोजेक्ट चुनें',
    'common.selectAssignee': 'असाइनी चुनें',
    'common.searchAssignees': 'असाइनी खोजें...',
    'common.noAssigneesAvailable': 'कोई असाइनी उपलब्ध नहीं है।',
    'common.dueDateTime': 'नियत तारीख और समय',
    'common.files': 'फ़ाइलें',
    'common.links': 'लिंक',
    'common.addLink': 'लिंक जोड़ें',
    'common.na': 'उपलब्ध नहीं',
    'common.project': 'प्रोजेक्ट',
    'common.startDate': 'शुरुआत की तारीख',
    'common.endDate': 'समाप्ति की तारीख',
    'common.allMembers': 'सभी सदस्य',
    'common.applyFilters': 'फ़िल्टर लागू करें',
    'common.dashboard': 'डैशबोर्ड',
    'common.projects': 'प्रोजेक्ट्स',
    'common.createTask': 'टास्क बनाएं',
    'common.myTasks': 'मेरे टास्क',
    'common.calendar': 'कैलेंडर',
    'common.notifications': 'सूचनाएं',
    'notifications.unread': 'अपठित',
    'notifications.read': 'पढ़ी हुई',
    'notifications.noNotifications': 'कोई सूचना नहीं',
    'notifications.viewAll': 'सभी सूचनाएं देखें',
    'notifications.allNotifications': 'सभी सूचनाएं',
    'notifications.noNotificationsFound': 'कोई सूचना नहीं मिली।',
    'notifications.from': 'की ओर से',
    'notifications.live': 'लाइव',
    'manager.teamPerformance': 'टीम सदस्य प्रदर्शन',
    'calendar.title': 'कैलेंडर - स्वागत है {{name}}',
    'calendar.sun': 'रवि',
    'calendar.mon': 'सोम',
    'calendar.tue': 'मंगल',
    'calendar.wed': 'बुध',
    'calendar.thu': 'गुरु',
    'calendar.fri': 'शुक्र',
    'calendar.sat': 'शनि',
    'calendar.tasksOnDate': '{{date}} के कार्य',
    'calendar.noTasksForDate': 'इस तारीख के लिए कोई कार्य नहीं है।',
    'calendar.selectAction': 'क्रिया चुनें',
    'calendar.sendForApproval': 'स्वीकृति हेतु भेजें',
    'calendar.submitTask': 'कार्य सबमिट करें',
    'calendar.taskAttachments': 'कार्य अटैचमेंट्स',
    'calendar.noTaskAttachments': 'कोई कार्य अटैचमेंट नहीं है।',
    'calendar.submission': 'सबमिशन',
    'calendar.noSubmissionAttachments': 'कोई सबमिशन अटैचमेंट नहीं है।',
    'teamPerformance.title': 'टीम प्रदर्शन - स्वागत है {{name}}',
    'teamPerformance.filterTitle': 'प्रदर्शन डेटा फ़िल्टर करें',
    'teamPerformance.cardsTitle': 'प्रदर्शन कार्ड',
    'teamPerformance.noData': 'कोई प्रदर्शन डेटा उपलब्ध नहीं है।',
    'teamPerformance.role': 'भूमिका',
    'teamPerformance.totalTasks': 'कुल कार्य',
    'teamPerformance.completed': 'पूर्ण',
    'teamPerformance.ongoing': 'चल रहे',
    'teamPerformance.pendingApproval': 'लंबित स्वीकृति',
    'teamPerformance.overdue': 'समयसीमा पार',
    'teamPerformance.efficiencyScore': 'दक्षता स्कोर',
    'teamPerformance.failedFilter': 'प्रदर्शन डेटा फ़िल्टर करने में विफल।',
    'teamPerformance.appraisalEndpointMissing': 'मूल्यांकन रिपोर्ट API नहीं मिली। कृपया API कॉन्फ़िगरेशन जांचें।',
    'teamPerformance.accessDenied': 'एक्सेस अस्वीकृत। मूल्यांकन डेटा के लिए एडमिन से संपर्क करें।',
    'dashboard.majorTask': 'मेजर टास्क',
    'auth.manager': 'मैनेजर',
    'auth.teamMember': 'टीम सदस्य',
    'myTasks.failedLoad': 'टास्क लोड नहीं हुए। कृपया फिर से प्रयास करें।',
    'toast.taskSentApproval': 'कार्य स्वीकृति हेतु भेज दिया गया!',
    'toast.failedSendApproval': 'कार्य स्वीकृति हेतु भेजने में विफल।',
    'toast.taskUpdatedSuccess': 'कार्य स्थिति सफलतापूर्वक अपडेट हुई!',
    'toast.failedUpdateTaskStatus': 'कार्य स्थिति अपडेट करने में विफल।',
    'manager.welcome': 'डैशबोर्ड - स्वागत है {{name}}',
    'manager.ongoingProjects': 'चल रहे प्रोजेक्ट्स',
    'manager.completedProjects': 'पूर्ण प्रोजेक्ट्स',
    'manager.majorTasksToday': 'आज के मेजर टास्क',
    'manager.pendingApprovals': 'लंबित अनुमोदन',
    'manager.noMajorTasksDueToday': 'आज कोई मेजर टास्क नियत नहीं है।',
    'manager.noPendingApprovals': 'कोई लंबित अनुमोदन नहीं है।',
    'manager.noTasksAssigned': 'आपको कोई टास्क असाइन नहीं है।',
    'manager.subtaskTitle': 'सबटास्क शीर्षक',
    'manager.teamMember': 'टीम सदस्य',
    'manager.action': 'कार्यवाही',
    'manager.approveTask': 'टास्क स्वीकृत करें',
    'manager.declineTask': 'टास्क अस्वीकार करें',
    'manager.taskApprovedSuccess': 'टास्क सफलतापूर्वक स्वीकृत हुआ!',
    'manager.taskDeclinedSuccess': 'टास्क सफलतापूर्वक अस्वीकृत हुआ!',
    'manager.failedApproveTask': 'टास्क स्वीकृत करने में विफल।',
    'manager.failedDeclineTask': 'टास्क अस्वीकार करने में विफल।',
    'createTask.welcome': 'टास्क बनाएं - स्वागत है {{role}}',
    'createTask.createMajorTask': 'मेजर टास्क बनाएं',
    'createTask.majorTaskName': 'मेजर टास्क नाम',
    'createTask.subtasks': 'सबटास्क',
    'createTask.noSubtasksAdded': 'कोई सबटास्क नहीं जोड़ा गया।',
    'createTask.addSubtask': 'सबटास्क जोड़ें',
    'createTask.attachFilesOptional': 'फ़ाइलें जोड़ें (वैकल्पिक)',
    'createTask.maxFilesHelp': 'अधिकतम 5 फ़ाइलें, कुल 25MB।',
    'createTask.attachLinksOptional': 'लिंक जोड़ें (वैकल्पिक)',
    'createTask.maxLinksHelp': 'अधिकतम 5 लिंक।',
    'createTask.noLinksAdded': 'कोई लिंक नहीं जोड़ा गया।',
    'createTask.submitMajorTask': 'मेजर टास्क सबमिट करें',
    'createTask.creatingTask': 'टास्क बनाया जा रहा है...',
    'createTask.teamWorkloadOverview': 'टीम वर्कलोड अवलोकन',
    'createTask.noOngoingTasks': 'कोई चालू टास्क नहीं!',
    'toast.failedLoadData': 'डेटा लोड नहीं हुआ। कृपया फिर से प्रयास करें।',
    'toast.userDataUnavailable': 'यूज़र डेटा उपलब्ध नहीं है।',
    'toast.maxLinksAllowed': 'अधिकतम 5 लिंक की अनुमति है।',
    'toast.subtaskFieldsRequired': 'विवरण को छोड़कर सभी सबटास्क फ़ील्ड अनिवार्य हैं।',
    'toast.dueFuture': 'नियत तारीख और समय भविष्य में होना चाहिए।',
    'toast.subtaskAdded': 'सबटास्क जोड़ दिया गया। टास्क बनाने के लिए सबमिट करें।',
    'toast.taskCreationInProgress': 'टास्क बन रहा है। कृपया प्रतीक्षा करें।',
    'toast.completeRequiredFields': 'कृपया सभी अनिवार्य फ़ील्ड भरें और कम से कम एक सही सबटास्क जोड़ें।',
    'toast.selectValidProject': 'कृपया एक सही प्रोजेक्ट चुनें।',
    'toast.creatingTaskWait': 'टास्क बनाया जा रहा है, कृपया प्रतीक्षा करें...',
    'toast.taskCreated': 'मेजर टास्क और सबटास्क सफलतापूर्वक बन गए!',
    'toast.failedCreateTask': 'टास्क बनाने में विफल।',
    'task.low': 'निम्न',
    'task.medium': 'मध्यम',
    'task.high': 'उच्च',
    'task.ongoing': 'चल रहा',
    'task.completed': 'पूर्ण',
    'landing.homeAria': 'PutPens होम',
    'landing.learnMore': 'और जानें',
    'landing.faq': 'सामान्य प्रश्न',
    'landing.support': 'सहायता',
    'landing.menu': 'मेनू',
    'landing.login': 'लॉग इन',
    'landing.heroLine1': 'बेहतर योजना बनाएं।',
    'landing.heroLine2': 'तेजी से बनाएं।',
    'landing.heroLine3': 'स्मार्ट नेतृत्व करें।',
    'landing.heroSubtitle': 'अपनी टीम और संसाधनों को अब और स्मार्ट तरीके से प्रबंधित करें।',
    'landing.getStarted': 'शुरू करें',
    'landing.alreadyStarted': 'क्या आपने पहले ही साइन अप शुरू कर दिया है?',
    'landing.whyTitle': 'PutPens क्यों?',
    'landing.whyBody': 'PutPens प्रोजेक्ट मैनेजमेंट को आसान और सहज बनाता है। अपनी टीम के साथ प्रोजेक्ट प्लान करें, कार्य सौंपें और प्रगति को बिना झंझट ट्रैक करें। हर साइट पर सफल नेतृत्व का स्मार्ट तरीका।',
    'landing.feature1Title': 'पारदर्शी मूल्यांकन',
    'landing.feature1Body': 'पूर्ण कार्य, डेडलाइन और गुणवत्ता स्कोर के आधार पर स्वचालित मूल्यांकन।',
    'landing.feature2Title': 'स्मार्ट रिमाइंडर',
    'landing.feature2Body': 'समय पर कार्य पूरा कराने के लिए स्वचालित रिमाइंडर और फॉलो-अप।',
    'landing.feature3Title': 'प्रदर्शन अंतर्दृष्टि',
    'landing.feature3Body': 'टीम प्रदर्शन और उत्पादकता ट्रैक करने के लिए रियल-टाइम एनालिटिक्स।',
    'landing.ctaTitle': 'क्या आप शुरू करने के लिए तैयार हैं?',
    'landing.startTrial': 'अपना फ्री ट्रायल शुरू करें',
    'landing.exploreFaq': 'FAQs देखें',
    'landing.needHelp': 'मदद चाहिए?',
    'landing.helpBody': 'कोई समस्या है या कोई सवाल? हमारी टीम आपकी मदद के लिए तैयार है।',
    'landing.goSupport': 'सहायता पर जाएं',
    'landing.footer': '© 2025 PutPens. सर्वाधिकार सुरक्षित।',
  },
};

export default translations;
